import AoneService from "../axiosbase";
//get provider
export const getProvider = async (params) => {
    try  {
        return await AoneService.get(`pls/api/v1/providers${params}`)
    } catch (error) {
        return error;
    }
}
//post provider
export const postProvider = async (data) => {
    try {
      return await AoneService.post(`pls/api/v1/providers`,data);
    } catch (error) {
      return error;
    }
  };
//get provider by id
export const getProviderbyId = async (params) => {
    try {
      return await AoneService.get(`pls/api/v1/providers/${params}`);
    } catch (error) {
      return error;
    }
  };
//update provider
export const updateProvider = async (data) => {
   try {
     return await AoneService.put(`pls/api/v1/providers`,data);
   } catch (error) {
     return error;
   }
 };
 //delete provider
 export const deleteProvider = async (params) => {
   try {
     return await AoneService.delete(`pls/api/v1/providers/${params}`);
   } catch (error) {
     return error;
   }
 };
 //export provider
 export const exportProvider = async (params) => {
   try {
     const response = await AoneService.get(
       `pls/api/v1/providers/export${params}`, 
       { responseType: "blob" }
     );
     return response;
   } catch (error) {
     return error;
   }
 };
//lookup-tool
export const getProvierStatus = async () => {
    try {
      return await AoneService.get(`pls/api/v1/lookups/ProviderStatus`);
    } catch (error) {
      return error;
    }
  };
  export const getRequestStatus = async () => {
    try {
      return await AoneService.get(`pls/api/v1/lookups/PLRequestStatus`);
    } catch (error) {
      return error;
    }
  };
export const getWeightUnit = async () => {
    try {
      return await AoneService.get(`pls/api/v1/lookups/WeightUnit`);
    } catch (error) {
      return error;
    }
  };
  export const getParcelType = async () => {
    try {
      return await AoneService.get(`pls/api/v1/lookups/ParcelType`);
    } catch (error) {
      return error;
    }
  };
  export const getUserStatus = async () => {
   try {
     return await AoneService.get(`pls/api/v1/lookups/UserStatus`);
   } catch (error) {
     return error;
   }
 };
 export const getFlagType = async () => {
  try {
    return await AoneService.get(`ops/api/v1/lookups/FlagType`);
  } catch (error) {
    return error;
  }
};
 export const getFlagStatus = async () => {
  try {
    return await AoneService.get(`ops/api/v1/lookups/FlagStatus`);
  } catch (error) {
    return error;
  }
};
 export const getPlReasonType = async () => {
  try {
    return await AoneService.get(`ops/api/v1/lookups/ParcelLockerReasonType`);
  } catch (error) {
    return error;
  }
};
 export const getPlTasksType = async () => {
  try {
    return await AoneService.get(`ops/api/v1/lookups/ParcelLockerTaskAction`);
  } catch (error) {
    return error;
  }
};
 //allowed dimension 
//post dimensions
export const postDimensions = async (data) => {
   try {
     return await AoneService.post(`pls/api/v1/provider/dimensions`,data);
   } catch (error) {
     return error;
   }
 };
//update dimensions
export const updateDimensions = async (params,data) => {
   try {
     return await AoneService.put(`pls/api/v1/provider/dimensions/${params}`,data);
   } catch (error) {
     return error;
   }
 };
//delete dimensions
export const deleteDimensions = async (params) => {
   try {
     return await AoneService.delete(`pls/api/v1/provider/dimensions/${params}`);
   } catch (error) {
     return error;
   }
 };
 //allowed city
//post city
export const postCities = async (data) => {
   try {
     return await AoneService.post(`pls/api/v1/provider/cities`,data);
   } catch (error) {
     return error;
   }
 };
//update city
export const updateCities = async (params,data) => {
   try {
     return await AoneService.put(`pls/api/v1/provider/cities/${params}`,data);
   } catch (error) {
     return error;
   }
 };
//delete city
export const deleteCities = async (params) => {
   try {
     return await AoneService.delete(`pls/api/v1/provider/cities/${params}`);
   } catch (error) {
     return error;
   }
 };
 //courier user
 //post user
 export const postUser = async (data) => {
   try {
     return await AoneService.post(`pls/api/v1/provider/users`,data);
   } catch (error) {
     return error;
   }
 };
 //update status
 export const updateStatus = async (param,params) => {
   try {
     return await AoneService.patch(`pls/api/v1/provider/users/${param}/status?status=${params}`);
   } catch (error) {
     return error;
   }
 };
 //get password
 export const getPasswordbyId = async (params) => {
   try {
     return await AoneService.get(`pls/api/v1/provider/users/${params}/password`);
   } catch (error) {
     return error;
   }
 };
 //update password
 export const updatePassword = async (param,params) => {
   try {
     return await AoneService.patch(`pls/api/v1/provider/users/${param}/password?pwd=${params}`);
   } catch (error) {
     return error;
   }
 };
 //get user by provider code
 export const getUserbyProviderCode = async (params) => {
   try {
     return await AoneService.get(`pls/api/v1/provider/users`,params);
   } catch (error) {
     return error;
   }
 };
 //filter user by provider code
 export const filterProviderbyCode = async (data) => {
   try {
     return await AoneService.get(`pls/api/v1/provider/users/filter${data}`);
   } catch (error) {
     return error;
   }
 };
 //delete user
 export const deleteUser = async (params) => {
  try {
    return await AoneService.delete(`pls/api/v1/provider/users/${params}`);
  } catch (error) {
    return error;
  }
};
 //pl flags
 export const getFlags = async (params) => {
  try  {
      return await AoneService.get(`ops/api/v1/flags${params}`)
  } catch (error) {
      return error;
  }
}
//post flags
export const postFlags = async (data) => {
  try {
    return await AoneService.post(`ops/api/v1/flags`,data);
  } catch (error) {
    return error;
  }
};
//export flags
export const exportFlags = async (params) => {
  try {
    return await AoneService.get(`ops/api/v1/flags/export${params}`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//get flags by id
export const getFlagsbyId = async (params) => {
  try {
    return await AoneService.get(`ops/api/v1/flags/${params}`);
  } catch (error) {
    return error;
  }
};
//update flags
export const updateFlags = async (params,data) => {
 try {
   return await AoneService.put(`ops/api/v1/flags/${params}`,data);
 } catch (error) {
   return error;
 }
};
//resolve flags
export const resolveFlags = async (params) => {
  try {
    return await AoneService.put(`ops/api/v1/flags/${params}/resolve`);
  } catch (error) {
    return error;
  }
 };
//print flag
export const printFlag = async (params) => {
  try {
    return await AoneService.get(`ops/api/v1/flags/${params}/print`, {
      responseType: "blob",
    });
  } catch (error) {
    return error;
  }
};
//requests api
export const getRequests = async (params) => {
  try  {
      return await AoneService.get(`pls/api/v1/requests/filter${params}`)
  } catch (error) {
      return error;
  }
}
//post request
export const postRequest = async (data) => {
  try {
    return await AoneService.post(`pls/api/v1/requests`,data);
  } catch (error) {
    return error;
  }
};
//request export
export const exportRequest= async (params) => {
  try {
    const response = await AoneService.get(
      `pls/api/v1/requests/export${params}`, 
      { responseType: "blob" }
    );
    return response;
  } catch (error) {
    return error;
  }
};
//delete request
export const deleteRequest = async (params) => {
  try {
    return await AoneService.delete(`pls/api/v1/requests/${params}`);
  } catch (error) {
    return error;
  }
};
export const editRequest = async (params,data) => {
  try {
    return await AoneService.post(`pls/api/v1/requests/${params}`,data);
  } catch (error) {
    return error;
  }
};
//pl request events track
export const trackRequests = async (params) => {
  try  {
      return await AoneService.get(`pls/api/v1/request/events${params}`)
  } catch (error) {
      return error;
  }
}

//PL Tasks
export const getPlTasks = async (params) => {
  try  {
      return await AoneService.get(`ops/api/v1/pl/tasks${params}`)
  } catch (error) {
      return error;
  }
}
//post provider
export const postPlTasks = async (data) => {
  try {
    return await AoneService.post(`ops/api/v1/pl/tasks`,data);
  } catch (error) {
    return error;
  }
};
//get provider by id
export const PlTasksExport = async (params) => {
  try {
    return await AoneService.post(`ops/api/v1/pl/tasks/export${params}`);
  } catch (error) {
    return error;
  }
};
//update provider
export const deletePlTasks = async (params) => {
 try {
   return await AoneService.delete(`ops/api/v1/pl/tasks/${params}`);
 } catch (error) {
   return error;
 }
};

export const getPlStatus = async () => {
  try {
      return await AoneService.get(`ops/api/v1/lookups/ParcelLockerTaskStatus`)
  } catch (error) {
      return error;
  }
}
export const getPaymentLink = async (data) => {
  try {
      return await AoneService.post(`pg/api/v1/payment/link`,data)
  } catch (error) {
      return error;
  }
}
//PL TASKS
//List couriers
 export const listPlCouriersbyProvider = async (data) => {
   try {
     return await AoneService.get(`pls/api/v1/provider/filter${data}`);
   } catch (error) {
     return error;
   }
 };
 //Import,template-assign nd unassign
 export const importBulkAssign = async (data) => {
    try {
      return await AoneService.post(`ops/api/v1/pl/tasks/assign/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  export const bulkAssignTemplate = async () => {
    try {
      return await AoneService.get(
        `ops/api/v1/pl/tasks/assign/template/download`,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  export const importBulkUnassign = async (data) => {
    try {
      return await AoneService.post(`ops/api/v1/pl/tasks/unassign/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  export const bulkUnassignTemplate = async () => {
    try {
      return await AoneService.get(
        `ops/api/v1/pl/tasks/unassign/template/download`,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //user management bulk
  export const importUserManagementBulk = async (params,data) => {
    try {
      return await AoneService.post(`pls/api/v1/provider/${params}/users/upload`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  export const userManagementBulkTemplate = async () => {
    try {
      return await AoneService.get(
        `pls/api/v1/provider/users/template/download`,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }   
  };      
  export const importParcelLockerRequest = async (data) => {
    try {
      return await AoneService.post(`pls/api/v1/requests/upload`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  export const parcelLockerRequestTemplate = async () => {
    try {
      return await AoneService.get(
        `pls/api/v1/requests/template/download`,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }   
  };               